import { useMultipleChartsExport } from '@ecosystem/export-utils';
import { useMemo } from 'react';

const partitionRows = <T>(rows: T[], rowsPerSlide: number = 10): T[][] => {
  const numberOfPartitions = Math.ceil(rows.length / rowsPerSlide);

  return Array.from({ length: numberOfPartitions }, (_, i) =>
    rows.slice(i * rowsPerSlide, (i + 1) * rowsPerSlide),
  );
};

export const usePartitionChartExport = <T>(data: T[], rowsPerSlide?: number) => {
  const partitionedRowsData = useMemo(
    () => partitionRows(data, rowsPerSlide),
    [data, rowsPerSlide],
  );

  const { exportCallbacks } = useMultipleChartsExport(partitionedRowsData.length);

  return {
    partitionedRowsData,
    exportCallbacks,
  };
};
